"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isValidColorItem = function (value) {
    return !!(value && value.type && value.value !== undefined);
};
exports.isGuidColorItem = function (color) {
    return isValidColorItem(color) && color.type === "guid";
};
exports.isRgbColorItem = function (color) {
    return isValidColorItem(color) && color.type === "rgb";
};
function isApiExecutionResponseError(error) {
    return !!error.executionResponse;
}
exports.isApiExecutionResponseError = isApiExecutionResponseError;
